import { CallState } from "redmond";
import { IStoreState } from "../../../../reducers/types";

export const getAreOfferDetailsLoading = (state: IStoreState) => {
  return state.wallet.fetchTravelWalletDetailsCallState === CallState.InProcess;
};
